<template>
    <div class="c-autocomplete c-autocomplete--alt" v-click-outside="close">
        <input class="c-autocomplete__input"
               type="text"
               :placeholder="placeholder"
               autocomplete="off"
               v-model="keywords"
               @input="search"
               @change="select(keywords)" />

        <div class="c-autocomplete__results" :class="{'c-autocomplete__results--open': visible}">
            <ul class="c-autocomplete__results-list">
                <li class="autocomplete-result"
                    v-for="(result, index) in results"
                    :value="result.name"
                    :key="index"
                    @click="select(result)">
                    <span>{{ result.name }}</span>
                    <span>({{ result.count }})</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import clickOutside from "../directives/click-outside.js";

    export default {
        props: {
            keywords: { type: String },
            results: { type: Array },
            placeholder: { type: String }
        },
        data: function () {
            return {
                visible: false
            }
        },
        methods: {
            search: function () {
                this.$emit("search", this.keywords);
                if (this.results) {
                    this.visible = true;
                }
            },
            select: function (result) {
                this.$emit("select", result);
            },
            close: function () {
                this.visible = false
            }
        },
        directives: {
            clickOutside
        }
    };
</script>